// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Practitioner Details Page */
.practitioner-details-container {
    padding: 5rem 2rem;
    text-align: center;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(135deg, var(--clr-primary-9) 0%, var(--clr-primary-4) 100%);
    position: relative;
    animation: fadeIn 0.5s ease-in-out;
    font-family: var(--ff-primary);
  }
  
  /* Header Section */
  .practitioner-header {
    display: flex;
    flex-wrap: wrap; /* Allows wrapping on smaller screens */
    gap: 2rem;
    align-items: flex-start;
    width: 100%;
    max-width: 1200px;
    margin-bottom: 3rem;
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-3);
    text-align: left;
  }
  
  /* Image Section */
  .practitioner-image-container {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .practitioner-image {
    width: 250px !important;
    height: 250px !important;
    /* border-radius: 50%; */
    object-fit: cover;
    box-shadow: var(--shadow-2);
    transition: transform 0.3s ease;
  }
  
  .practitioner-image:hover {
    transform: scale(1.05);
  }
  
  .social-icons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
  }
  
  .icon {
    font-size: 1.5rem;
    text-decoration: none;
    color: var(--clr-primary-5);
    transition: color 0.3s ease, transform 0.2s ease;
  }
  
  .icon:hover {
    color: var(--clr-primary-6);
    transform: scale(1.2);
  }
  
  .book-now-button {
    background: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: var(--radius);
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: var(--transition);
    margin-top: 1rem;
  }
  
  .book-now-button:hover {
    background: var(--clr-primary-6);
    transform: scale(1.05);
    box-shadow: var(--shadow-2);
  }
  
  /* Details Section */
  .practitioner-details {
    flex: 2 1;
  }
  
  /* Practitioner Name - Main Heading */
.practitioner-name {
    font-size: 2rem; 
    color: var(--clr-primary-3); 
    margin-bottom: 0.5rem; 
    text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.1); 
    font-family: 'Roboto', sans-serif; 
    font-weight: 700; 
    text-transform: capitalize; 
  }
  
  /* Practitioner Title - Subtitle */
  .practitioner-title {
    font-size: 1.4rem; 
    color: var(--clr-primary-5); 
    margin-bottom: 1rem; 
    font-style: italic;
    font-weight: 500;
    letter-spacing: 0.5px; 
    font-family: 'Open Sans', sans-serif; 
  }
  
  
  .practitioner-license {
    font-size: 1.1rem;
    color: var(--clr-grey-1);
    margin-bottom: 1rem;
  }
  
  .practitioner-intro {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
    line-height: 1.8;
    margin-bottom: 1rem;
    text-align: justify;
  }
  
  /* About Me Section */
  .about-me-section {
    width: 100%;
    max-width: 1200px;
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-3);
    text-align: left;
  }
  
  .about-me-section h2 {
    font-size: 2rem;
    color: var(--clr-primary-3);
    margin-bottom: 1rem;
  }
  
  .about-me-section p {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
    line-height: 1.8;
    margin-bottom: 1rem;
  }
  
  /* Responsive Styles */
  @media (max-width: 768px) {
    .practitioner-header {
      flex-direction: column;
      text-align: center;
    }
  
    .practitioner-details {
      text-align: center;
    }
  
    .about-me-section {
      text-align: justify;
    }
  }
  
/* Loading Spinner Styles */
.loading-spinner {
    border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */
    border-left-color: var(--clr-primary-5); /* Highlighted border */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 2rem auto;
  }
  
  /* Spinner Animation */
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/DoctorsPortal/PractitionersDetails.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,uFAAuF;IACvF,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe,EAAE,uCAAuC;IACxD,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,iBAAiB;IACjB,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;EAClD;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,oBAAoB;EACpB;IACE,SAAO;EACT;;EAEA,qCAAqC;AACvC;IACI,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;IACrB,2CAA2C;IAC3C,iCAAiC;IACjC,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,oCAAoC;EACtC;;;EAGA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;EACF;;AAEF,2BAA2B;AAC3B;IACI,oCAAoC,EAAE,iBAAiB;IACvD,uCAAuC,EAAE,uBAAuB;IAChE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE;MACE,yBAAyB;IAC3B;EACF","sourcesContent":["/* Practitioner Details Page */\n.practitioner-details-container {\n    padding: 5rem 2rem;\n    text-align: center;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    background: linear-gradient(135deg, var(--clr-primary-9) 0%, var(--clr-primary-4) 100%);\n    position: relative;\n    animation: fadeIn 0.5s ease-in-out;\n    font-family: var(--ff-primary);\n  }\n  \n  /* Header Section */\n  .practitioner-header {\n    display: flex;\n    flex-wrap: wrap; /* Allows wrapping on smaller screens */\n    gap: 2rem;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 1200px;\n    margin-bottom: 3rem;\n    background: var(--clr-white);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3);\n    text-align: left;\n  }\n  \n  /* Image Section */\n  .practitioner-image-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  .practitioner-image {\n    width: 250px !important;\n    height: 250px !important;\n    /* border-radius: 50%; */\n    object-fit: cover;\n    box-shadow: var(--shadow-2);\n    transition: transform 0.3s ease;\n  }\n  \n  .practitioner-image:hover {\n    transform: scale(1.05);\n  }\n  \n  .social-icons {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    margin-top: 1rem;\n  }\n  \n  .icon {\n    font-size: 1.5rem;\n    text-decoration: none;\n    color: var(--clr-primary-5);\n    transition: color 0.3s ease, transform 0.2s ease;\n  }\n  \n  .icon:hover {\n    color: var(--clr-primary-6);\n    transform: scale(1.2);\n  }\n  \n  .book-now-button {\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    padding: 0.8rem 1.5rem;\n    border-radius: var(--radius);\n    font-size: 1rem;\n    font-weight: bold;\n    cursor: pointer;\n    transition: var(--transition);\n    margin-top: 1rem;\n  }\n  \n  .book-now-button:hover {\n    background: var(--clr-primary-6);\n    transform: scale(1.05);\n    box-shadow: var(--shadow-2);\n  }\n  \n  /* Details Section */\n  .practitioner-details {\n    flex: 2;\n  }\n  \n  /* Practitioner Name - Main Heading */\n.practitioner-name {\n    font-size: 2rem; \n    color: var(--clr-primary-3); \n    margin-bottom: 0.5rem; \n    text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.1); \n    font-family: 'Roboto', sans-serif; \n    font-weight: 700; \n    text-transform: capitalize; \n  }\n  \n  /* Practitioner Title - Subtitle */\n  .practitioner-title {\n    font-size: 1.4rem; \n    color: var(--clr-primary-5); \n    margin-bottom: 1rem; \n    font-style: italic;\n    font-weight: 500;\n    letter-spacing: 0.5px; \n    font-family: 'Open Sans', sans-serif; \n  }\n  \n  \n  .practitioner-license {\n    font-size: 1.1rem;\n    color: var(--clr-grey-1);\n    margin-bottom: 1rem;\n  }\n  \n  .practitioner-intro {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n    line-height: 1.8;\n    margin-bottom: 1rem;\n    text-align: justify;\n  }\n  \n  /* About Me Section */\n  .about-me-section {\n    width: 100%;\n    max-width: 1200px;\n    background: var(--clr-white);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3);\n    text-align: left;\n  }\n  \n  .about-me-section h2 {\n    font-size: 2rem;\n    color: var(--clr-primary-3);\n    margin-bottom: 1rem;\n  }\n  \n  .about-me-section p {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n    line-height: 1.8;\n    margin-bottom: 1rem;\n  }\n  \n  /* Responsive Styles */\n  @media (max-width: 768px) {\n    .practitioner-header {\n      flex-direction: column;\n      text-align: center;\n    }\n  \n    .practitioner-details {\n      text-align: center;\n    }\n  \n    .about-me-section {\n      text-align: justify;\n    }\n  }\n  \n/* Loading Spinner Styles */\n.loading-spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */\n    border-left-color: var(--clr-primary-5); /* Highlighted border */\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin: 2rem auto;\n  }\n  \n  /* Spinner Animation */\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
